import { createSlice } from "@reduxjs/toolkit";
import { getPreMadeTemplates } from "../requests";

const initialState = {
  preTempates: [],
  activePremadeTemplateId: null,
};

const preMadeTemplates = createSlice({
  name: "preMadeTemplates",
  initialState,
  reducers: {
    setActivePremadeTemplateId(state, { payload }) {
      state.activePremadeTemplateId = payload;
    },
  },
  extraReducers: {
    [getPreMadeTemplates.fulfilled]: (state, { payload }) => {
      state.preTempates = payload;
    },
  },
});
export const { setActivePremadeTemplateId } = preMadeTemplates.actions;
export default preMadeTemplates.reducer;
